import Loading from 'app/atoms/Loading';
import { Suspense, useEffect, useState } from 'react';
import './HelpCenter.scss';
import HelpCenterHeroSection from './HelpCenterHeroSection/HelpCenterHeroSection';
import HelpCenterFAQSection from './HelpCenterFAQSection/HelpCenterFAQSection';
import { sanityClient } from 'sanity.io/config';
import { HelpCenterSanity } from './HelpCenter.types';

function HelpCenter() {
  const [data, setData] = useState<HelpCenterSanity[]>();

  useEffect(() => {
    sanityClient.fetch<HelpCenterSanity[]>(`*[ _type== "faq" && displayInHelpCenter == true] | order(sortOrder asc)`).then(response => {
      if (response && response[0]) {
        setData(response);
      }
    });
  }, []);

  return (
    <Suspense
      fallback={
        <div>
          <Loading force={true} />
        </div>
      }
    >
      <HelpCenterHeroSection />
      <section className="d-flex flex-column pb-5">
        {data && <HelpCenterFAQSection sanityData={data} />}
        {/*<HelpCenterContactUsSection />*/} {/*Probably after MVP*/}
      </section>
    </Suspense>
  );
}
export default HelpCenter;
